module.exports = __webpack_public_path__ + "static/media/allan.624f0523.jpg";